import React from "react";
import styled from "styled-components";
import { GlossyThemeProvider, dominant } from "@glossy";
import Button from "@ui-kit/button";
import Selector from "@radarly/components/panels/card-edition/chart-selector";
import { useFacetsFromContext } from "@radarly/core/facets/use-cases";
import { useCurrentProjectFocusesId } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { useCurrentWorkspaceId } from "@radarly/core/workspace/use-cases";
import { tr } from "@radarly/i18n";
import { Card, CardWithTerm } from "@radarly/models/cards";
import { setCardPivotTerm } from "@radarly/models/cards/editor";
import { getAvailableFacetsFromCard } from "@radarly/models/cards/form";
import { CardTerm, getTermsFromPivotCard } from "@radarly/models/cards/term";

interface SharedPanelsCardEditionSidebarProps {
  card: Card;
  setCard: (card: Card) => void;
  closePanel: () => void;
}

const Text = styled(Button)<{ selected: boolean }>`
  box-shadow: ${(props) =>
    props.selected && `0 0 0 2px ${dominant(props)} inset`};
  width: 100%;
`;

const SharedPanelsCardEditionSidebar = ({
  card,
  setCard,
  closePanel,
}: SharedPanelsCardEditionSidebarProps) => {
  const { countries, ...facets } = useFacetsFromContext();
  const { against } = getTermsFromPivotCard(card);
  const locale = useCurrentUserLocale();
  const facetsFromCard = getAvailableFacetsFromCard(card, facets);
  const workspaceId = useCurrentWorkspaceId();
  const projectFocuses = useCurrentProjectFocusesId();
  return (
    <Selector
      title={tr(locale, "CUSTOM_PAGES::EDITOR::SECOND_ANALYZED_ATTRIBUTE")}
      sections={[{ values: facetsFromCard }]}
      selected={against}
      onClickBack={closePanel}
      renderItem={(single, item, selected, index) => (
        <GlossyThemeProvider name="tile" key={index}>
          <Text
            selected={item.value === selected}
            text={item.label}
            variant="tertiary"
            size="l"
            onClick={() =>
              setCard(
                setCardPivotTerm(
                  workspaceId,
                  projectFocuses,
                  card as CardWithTerm,
                  item.value as CardTerm,
                  facets
                )
              )
            }
          />
        </GlossyThemeProvider>
      )}
    />
  );
};

export default SharedPanelsCardEditionSidebar;
